import type {ReactNode} from 'react'

interface DialogBodyProps {
    children: ReactNode
    'data-testid'?: string
}

export function DialogBody({children, 'data-testid': testId}: DialogBodyProps) {
    return (
        <div className="py-4" data-testid={testId}>
            {children}
        </div>
    )
}
